import {
  Component,
  ViewEncapsulation,
} from '@angular/core';
import {
  BsModalRef,
  BsModalService,
} from 'ngx-bootstrap/modal';
import {
  InfoPageDialogComponent,
  InfoPageTemplate,
} from 'src/app/components';
import { FormFieldAbstractComponent } from 'src/app/lib/form-fields/form-field-abstract.component';

@Component({
  selector: 'app-form-field-checkbox-gdpr',
  templateUrl: './form-field-checkbox-gdpr.component.html',
  styleUrls: ['./form-field-checkbox-gdpr.component.scss'],
  encapsulation: ViewEncapsulation.None,
})
export class FormFieldCheckboxGdprComponent extends FormFieldAbstractComponent {
  modalRef?: BsModalRef;

  constructor(private modalService: BsModalService) {
    super();
  }

  preventClick(e: Event) {
    e.preventDefault();
    e.stopPropagation();
  }

  openDialog(pageTemplate: InfoPageTemplate): void {
    this.modalRef = this.modalService.show(
      InfoPageDialogComponent,
      {
        class: 'modal-lg',
        initialState: {
          template: pageTemplate,
        },
      }
    );
  }

  get checkBoxLabel(): string {
    return this.label;
  }

  get showError(): boolean {
    return this.field.touched && !this.field.valid;
  }

  get hasHint(): boolean {
    return null !== this.hint && !this.showError;
  }
}
